module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/icons-cloud-app-app-198f85ff2638730febfe36565674b79b.svg";